module.exports = {
  element: "div",
  className: "fullscreenModeContainerMain",
  gid: "fullscreenModeContainerMain",
  children: [
    {
      element: "div",
      className: "fullscreenModeContainer",
      gid: "fullscreenModeContainer",
      children: [],
    },
  ],
};
